
























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { SalePriceDisplayType } from '@/models/api/productclass'
import { Sku } from './model/item'
import { ApparelAddToCartSelectionState } from './selection-state'

@Component
export default class Price extends Vue {
  @Prop({ required: true })
  readonly state: ApparelAddToCartSelectionState

  @Prop({ required: true })
  readonly salePriceDisplayType: SalePriceDisplayType

  get shouldShow(): boolean {
    // ROOTに紐づく全てのSKUが同じ価格であれば、今選択しているFKU/SKUの価格も必ずその価格と一致する
    // その価格はページ中のROOTの価格表記に記載されているので、
    // ここではROOT中に異なる価格の商品が含まれている場合のみ表示を行う
    if (this.hasUniformSkuPrice) {
      return false
    }

    return this.selectedSku !== null
  }

  get priceText(): string {
    if (this.selectedSku) {
      return this.buildSkuPriceText(this.selectedSku)
    }

    return ''
  }

  get discountText(): string {
    if (this.selectedSku && this.selectedSku.isOnDiscountSale) {
      return this.buildDiscountText(
        `${this.selectedSku.discountRate}%OFF`,
        this.buildSkuDiscountAmountText(this.selectedSku)
      )
    }

    return ''
  }

  private get selectedSku(): Sku | null {
    return this.state.selectedSku.toNullable()
  }

  private get hasUniformSkuPrice(): boolean {
    const prices = this.state.fkuList.reduce<number[]>(
      (result, fku) => result.concat(
        fku.skuList.map(sku => sku.price.prices.selected.price)
      ),
      []
    )

    // 価格が1個未満であれば常にtrue
    // なお、全てのFKUがSKUを持たない場合のみpricesの長さは0になるが、そのFKUは非公開扱いなのでここには到達しない想定
    if (prices.length <= 1) {
      return true
    }

    const representativePrice = prices[0]

    for (let index = 1; index < prices.length; index += 1) {
      if (prices[index] !== representativePrice) {
        return false
      }
    }

    return true
  }

  private buildSkuPriceText(sku: Sku): string {
    return `${sku.formattedPrice}（税込）`
  }

  private buildDiscountText(rateText: string, amountText: string): string {
    if (this.salePriceDisplayType === 'absolute') {
      return amountText
    }

    return rateText
  }

  private buildSkuDiscountAmountText(sku: Sku): string {
    return `${this.formatJPYPrice(sku.discountAmount)} OFF`
  }

  private formatJPYPrice(price: number): string {
    return price.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })
  }
}
